<ion-content class="container">
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="12" size-md="6" size-lg="5" size-xs="12" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickVariablePaySetup('Setup')">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickVariablePaySetup('Setup')">Variable Pay / Setup</span> / <span
            [style.color]="buttonColorName">Upload Variable Pay Policy</span></label>
      </div>
    </ion-col>
  </ion-row>
   <!-- <div class="modal-body p-20">
    <ion-row>
      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="cardBox mb-20 p-20">
          <div>
            <button class="download-policy-btn" (click)="getDownloadPolicy()">
                Download Policy
            </button>
          </div>
          <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center mt-20 cp" (click)="browseImage.click()">
              <div class="upload-file-container">
                <ion-content>
                    <p>Browse and file select</p>
                    <p>OR</p>
                    <input type="file" (change)="onFileSelected($event)" id="fileInput" hidden/>
                    <button class="browse-btn" (click)="triggerFileInput()">
                      Browse
                    </button>
                    <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;">
                </ion-content>
              </div>
          </div>
          <div class="upload-file-validation">
              <p>One file only | 20 MB Limits</p>
          </div>
          <div class="btn-group">
            <button class="cancle-btn">Cancel</button>
            <button class="upload-policy-btn">Upload Policy</button>
          </div>
        </div>
      </ion-col>
    </ion-row>
    </div> -->

    <div class="modal-body p-20">
      <ion-row>
        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="cardBox mb-20 p-20">
            <button class="download-policy-btn font_medium mr-30 mt-10" [style.background-color]="buttonColorName" (click)="downloadVPPolicyFile()"
             >
              <img class="mr-10" src="././assets/icon/downloadWhite.svg">Download Policy</button>
            <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center mt-20 cp" (click)="browseImage.click()">
              <div class="upload-file-container">
                <p>Browse and file select</p> 
                      <p class="mt-5">OR</p>
                      <button class="browse-btn">
                        Browse
                      </button>
                <input #browseImage type="file" (change)="uploadVPFile($event)" style="display:none;">
              </div>
            </div>
            <div *ngIf="showBrowseBtn" class="w-100 upload-box display-center mt-20 cp">
              <div class="d-flex mb-20 mt-20">
                <div class="verticle-center mr-20">
                  <img src="././assets/icon/successImport.svg">
                </div>
                <div class="flex-column">
                  <label class="fs-14 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                  <div class="d-flex">
                    <label class="fs-12 blue font_medium cl-black mx-width">{{fileName}}</label>
                    <img src="././assets/icon/remove.png" class="removeIcon ml-5 cp" 
                    (click)="onRemoveUploadedFile()">
                  </div>
                </div>
              </div>
          </div>
          <div class="upload-file-validation">
            <p>One file only | 10 MB Limits</p>
          </div>
        <div class="btn-group">
          <button class="Cancel-btn" (click)="onClickCancelUploadPolicy()">Cancel</button>
          <button class="upload-policy-btn" [disabled]="isDisabledUploadPolicyBtn" (click)="saveVPPolicyFile()">Upload Policy</button> 
        </div>
        </div>
        </ion-col>
      </ion-row>
    </div>
  </ion-content>
